(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      // Throttle scroll to one run per animation frame. Without this the
      // handler fires 60-120x/sec on fast scroll and thrashes the hide/reveal
      // classes, making the header jump around. (Fast-scroll jank bug.)
      this.scrollTicking = false;
      this.onScrollHandler = () => {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        requestAnimationFrame(() => {
          this.onScroll();
          this.scrollTicking = false;
        });
      };
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      // Reset transient header state when the page is restored from the
      // back/forward cache (bfcache). Otherwise the stale currentScrollTop
      // makes the first scroll mis-detect direction and the header jumps
      // around on back-navigation to a PDP. (Back-nav bug.)
      this.onPageShow = (event) => {
        if (!event.persisted) return;
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.preventReveal = false;
        this.scrollTicking = false;
        if (!this.headerIsAlwaysSticky) {
          this.header.classList.remove(
            'shopify-section-header-hidden',
            'shopify-section-header-sticky',
            'animate'
          );
        }
        this.createObserver();
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('pageshow', this.onPageShow);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('pageshow', this.onPageShow);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  if (!window.__popupQueue) {
    window.__popupQueue = [];
    window.__popupQueueProcessed = false;
  }

  // ---------------------------------------------------------------------------
  // Newsletter (Welcome) popup has absolute priority. While it is eligible to
  // show (counting down its delay) or currently open, every popup-modal here
  // must stay hidden — even if its own trigger criteria are met. The newsletter
  // element (assets/newsletter-popup.js, loaded earlier in <head>) publishes
  // window.__newsletterPopupActive and toggles body.newsletter-popup-active.
  // ---------------------------------------------------------------------------
  function newsletterHasPriority() {
    return window.__newsletterPopupActive === true || document.body.classList.contains('newsletter-popup-active');
  }

  // ---------------------------------------------------------------------------
  // Exit-intent controller — powers popup-modal.on-leave-popup
  // ---------------------------------------------------------------------------

  class OnLeavePopupController {
    constructor(popup) {
      this.popup = popup;
      this.triggered = false;
      this.arrivedAt = Date.now();
      this.minTimeMs = 3000; // minimum time on page
      this.minScrollPct = 3; // minimum page scroll required

      // Touch / small-viewport devices have no reliable cursor exit-intent, so
      // they use a Back-button history trap instead. The trap also catches the
      // iOS/Android left-edge swipe-back gesture, which performs a history pop.
      // The old "rapid scroll-up" trigger was removed by client decision
      // because it fired during normal browsing and internal navigation.
      this.isTouch = window.matchMedia('(hover: none)').matches || window.matchMedia('(max-width: 991px)').matches;

      this._onMouseLeave = this._onMouseLeave.bind(this);
      this._onPopState = this._onPopState.bind(this);

      if (this.isTouch) {
        this._armBackTrap();
      } else {
        document.documentElement.addEventListener('mouseleave', this._onMouseLeave);
      }
    }

    // The Welcome (newsletter) popup takes priority while it is eligible to
    // show (still counting down its delay) or already open. The abandon popup
    // must never stack on top of it, and must yield during the delay window too.
    _welcomeActive() {
      return newsletterHasPriority();
    }

    _meetsGuardrails() {
      const elapsed = Date.now() - this.arrivedAt;
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPct = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 100;

      const timePassed = elapsed >= this.minTimeMs;
      const scrollPassed = scrollPct >= this.minScrollPct;

      if (!timePassed) return false;
      if (scrollable <= 0) return true;
      return scrollPassed;
    }

    // Desktop: cursor moves toward browser chrome (close/back/address bar)
    _onMouseLeave(e) {
      if (this.triggered) return;
      if (e.clientY > 20) return;
      if (this._welcomeActive()) return; // yield to Welcome; stay armed for a later exit
      if (!this._meetsGuardrails()) return;
      this._trigger();
    }

    // Mobile: trap the first Back tap. Only arm when there is somewhere to go
    // back to — otherwise Back exits the tab/site, which the page can't catch.
    _armBackTrap() {
      if (window.history.length <= 1) return;
      window.history.pushState({ bodiskinExitTrap: true }, '');
      window.addEventListener('popstate', this._onPopState);
    }

    // Fires after the trap entry has already been popped.
    _onPopState() {
      if (this.triggered) return; // already shown — let navigation proceed
      // When we must not show, honor the Back intent. Detach first so a
      // same-document Back doesn't re-fire this handler, then history.back()
      // leaves the page (the trap entry is already gone).
      if (this._welcomeActive() || !this._meetsGuardrails()) {
        window.removeEventListener('popstate', this._onPopState);
        window.history.back();
        return;
      }
      this._trigger();
    }

    _trigger() {
      if (this.triggered) return;
      this.triggered = true;
      this._cleanup();
      this.popup.show();
    }

    _cleanup() {
      document.documentElement.removeEventListener('mouseleave', this._onMouseLeave);
      window.removeEventListener('popstate', this._onPopState);
    }
  }

  class PopupModal extends HTMLElement {
    constructor() {
      super();
      console.log('[PopupModal] Constructor called');

      this.closeBtn = this.querySelector('[data-popup-close]');
      this.overlay = this.querySelector('[data-popup-overlay]');
      this.dialog = this.querySelector('[role="dialog"]');
      this.form = this.querySelector('form[data-popup-form]');

      console.log('[PopupModal] Form element found:', this.form);

      this.sectionId = this.dataset.sectionId || '';
      this.triggerType = this.dataset.trigger || 'scroll';
      this.delay = parseInt(this.dataset.delay || '3000', 10) || 3000;
      this.scrollThreshold = parseInt(this.dataset.scrollThreshold || '100', 10) || 100;
      this.dismissDays = parseInt(this.dataset.dismissDays || '7', 10);
      this.pushowlEnabled = this.dataset.pushowl === 'true';
      this.pushowlListId = this.dataset.pushowlListId || '';

      console.log('[PopupModal] Configuration:', {
        sectionId: this.sectionId,
        triggerType: this.triggerType,
        brevoEnabled: this.pushowlEnabled,
        brevoListId: this.pushowlListId || 'not set',
      });

      this._onKeyUp = this._onKeyUp.bind(this);
      this._onScroll = this._onScroll.bind(this);
      this._scrollBound = false;
      this._timeoutId = null;
    }

    connectedCallback() {
      console.log('[PopupModal] connectedCallback called');

      // Shopify customizer support
      if (this.dataset.designMode === 'true') {
        this._setupCustomizerEvents();
        return;
      }

      // Write permanent suppression key when success message is present after form submit
      if (this.querySelector('[data-popup-subscribed]')) {
        console.log('[PopupModal] Success message detected, marking as subscribed');
        try {
          localStorage.setItem('popup-subscribed', 'true');
        } catch (e) {
          console.error('[PopupModal] Error setting localStorage:', e);
        }
        return;
      }

      // Suppress permanently for users who previously subscribed
      try {
        if (localStorage.getItem('popup-subscribed') === 'true') {
          console.log('[PopupModal] User already subscribed, not showing popup');
          return;
        }
      } catch (e) {
        console.error('[PopupModal] Error checking localStorage:', e);
      }

      if (this._isDismissed()) {
        console.log('[PopupModal] Popup was dismissed recently, not showing');
        return;
      }

      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.hide());
      if (this.overlay) this.overlay.addEventListener('click', () => this.hide());

      console.log('[PopupModal] Checking Brevo setup - form:', !!this.form, 'brevoEnabled:', this.pushowlEnabled);

      // Submission is handled by the shared, hCaptcha-aware newsletter-ajax.js
      // (bound via the form's [data-ajax-newsletter] attribute, loaded globally
      // in theme.liquid). We must NOT run our own fetch/POST here: the old
      // _handleFormSubmit preventDefaulted and fetched directly, so Shopify's
      // invisible hCaptcha never ran, the POST carried no h-captcha-response
      // token, and Shopify bounced it to /challenge — which the old code then
      // followed via window.location.href. That was the "Something went wrong" +
      // full reload (and, on a PDP, a reload to a different colour variant because
      // ?variant was dropped) users saw on submit.
      //
      // We only react to newsletter-ajax's result events to render the popup's
      // in-place confirmation, and fire the optional Brevo identify on success.
      if (this.form) {
        const emailEl = this.form.querySelector('input[type="email"]');
        if (emailEl) {
          emailEl.addEventListener('input', () => {
            this._pendingEmail = emailEl.value.trim();
          });
        }
        this.form.addEventListener('newsletter:success', () => {
          const el = this.form.querySelector('input[type="email"]');
          const email = (el && el.value.trim()) || this._pendingEmail || '';
          this._showFormSuccess(this.form);
          if (this.pushowlEnabled && email) this._brevoIdentify(email);
        });
        this.form.addEventListener('newsletter:error', () => this._showFormError(this.form));
      } else if (this.pushowlEnabled) {
        console.warn('[PopupModal] ✗ Form element not found! Check data-popup-form attribute.');
      }

      this.querySelectorAll('[data-copy-discount]').forEach((btn) => {
        btn.addEventListener('click', () => this._copyDiscount(btn));
      });

      // Exit-intent popup: delegate to OnLeavePopupController, which chooses a
      // desktop (cursor) or mobile (Back-button) trigger. It never stacks on the
      // Welcome popup and never fires within the first few seconds.
      if (this.classList.contains('on-leave-popup')) {
        if (window.customerLoggedIn) return;
        new OnLeavePopupController(this);
        return;
      }

      window.__popupQueue.push(this);
      this._processQueue();
    }

    disconnectedCallback() {
      this._unbindTrigger();
      const idx = window.__popupQueue.indexOf(this);
      if (idx > -1) window.__popupQueue.splice(idx, 1);
    }

    _processQueue() {
      if (window.__popupQueueProcessed) return;
      window.__popupQueueProcessed = true;

      requestAnimationFrame(() => {
        // Newsletter popup wins — never arm a popup-modal while it is in play.
        if (newsletterHasPriority()) {
          window.__popupQueueProcessed = false;
          return;
        }

        window.__popupQueue.sort((a, b) => {
          const pos = a.compareDocumentPosition(b);
          if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
          if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;
          return 0;
        });

        for (const popup of window.__popupQueue) {
          if (!popup._isDismissed()) {
            popup._bindTrigger();
            break;
          }
        }

        window.__popupQueueProcessed = false;
      });
    }

    _isDismissed() {
      if (this.dismissDays <= 0) return false;
      try {
        const stored = localStorage.getItem('popup-dismissed-' + this.sectionId);
        if (!stored) return false;
        const diffDays = (Date.now() - parseInt(stored, 10)) / 86400000;
        return diffDays < this.dismissDays;
      } catch {
        return false;
      }
    }

    _storeDismiss() {
      try {
        localStorage.setItem('popup-dismissed-' + this.sectionId, Date.now().toString());
      } catch {
        // localStorage unavailable
      }
    }

    _bindTrigger() {
      if (this.triggerType === 'load') {
        this._timeoutId = setTimeout(() => this.show(), this.delay);
      } else if (this.triggerType === 'scroll') {
        if (window.scrollY >= this.scrollThreshold) {
          this.show();
        } else {
          window.addEventListener('scroll', this._onScroll, { passive: true });
          this._scrollBound = true;
        }
      }
      // 'custom_event': no automatic trigger — call .show() from your own code:
      // document.querySelector('popup-modal.your-class').show();
    }

    _unbindTrigger() {
      if (this._timeoutId) {
        clearTimeout(this._timeoutId);
        this._timeoutId = null;
      }
      if (this._scrollBound) {
        window.removeEventListener('scroll', this._onScroll);
        this._scrollBound = false;
      }
    }

    _onScroll() {
      if (window.scrollY >= this.scrollThreshold) {
        this._unbindTrigger();
        this.show();
      }
    }

    show() {
      console.log('[PopupModal] show() called');
      if (this._cancelClose) this._cancelClose();
      this._unbindTrigger();
      this.setAttribute('open', '');
      // Don't lock body scroll in design mode
      if (this.dataset.designMode !== 'true') {
        document.body.classList.add('overflow-hidden');
      }
      document.addEventListener('keyup', this._onKeyUp);
      if (typeof trapFocus === 'function' && this.dialog) trapFocus(this.dialog, this.dialog);
      console.log('[PopupModal] Popup is now visible');
    }

    hide() {
      // Slide variants play their exit animation before the popup is
      // actually removed; every other popup keeps the instant close. The
      // [closing] attribute drives the exit keyframes in CSS.
      if ((this.dataset.animation || '').indexOf('slide-') === 0 && this.hasAttribute('open')) {
        if (this.hasAttribute('closing')) return; // close already in progress
        this.setAttribute('closing', '');
        let finished = false;
        const done = () => {
          if (finished) return;
          finished = true;
          this._cancelClose = null;
          this.removeAttribute('closing');
          this._finishHide();
        };
        this._cancelClose = () => {
          finished = true;
          this._cancelClose = null;
          this.removeAttribute('closing');
        };
        if (this.dialog) this.dialog.addEventListener('animationend', done, { once: true });
        setTimeout(done, 700); // fallback in case animationend never fires
        return;
      }
      this._finishHide();
    }

    _finishHide() {
      console.log('[PopupModal] hide() called');
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keyup', this._onKeyUp);
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      // Don't store dismissal in design mode
      if (this.dataset.designMode !== 'true') {
        this._storeDismiss();
      }
      console.log('[PopupModal] Popup hidden and dismissed');
    }

    _onKeyUp(event) {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hide();
    }

    // Optional Brevo (PushOwl) dual-write, fired on a confirmed signup. The
    // Shopify submission itself is owned by newsletter-ajax.js; this only adds
    // the subscriber to Brevo with an exit-popup source tag. Non-blocking.
    _brevoIdentify(email) {
      if (!email) return;
      const tracker = window.Brevo || window.sendinblue;
      if (tracker && typeof tracker.push === 'function') {
        tracker.push(function () {
          tracker.identify({
            identifiers: { email_id: email },
            attributes: { SOURCE: 'exit_popup' },
          });
        });
      }
    }

    _showFormSuccess(form) {
      try {
        localStorage.setItem('popup-subscribed', 'true');
      } catch (e) {}

      const inner = form.querySelector('.popup-modal__form-inner');
      const disclaimer = form.querySelector('.popup-modal__form-disclaimer');
      if (inner) inner.hidden = true;
      if (disclaimer) disclaimer.hidden = true;

      let msg = form.querySelector('.popup-modal__msg--success');
      if (!msg) {
        msg = document.createElement('p');
        msg.className = 'popup-modal__msg popup-modal__msg--success';
        msg.setAttribute('role', 'alert');
        msg.setAttribute('aria-live', 'polite');
        form.prepend(msg);
      }
      msg.textContent = form.dataset.successMessage || "You're in! We'll keep you posted on skinwear news & updates.";
      msg.hidden = false;

      // Auto-close after 4 s; the close button / overlay still work meanwhile.
      this._successCloseTimer = setTimeout(() => this.hide(), 4000);
    }

    _showFormError(form) {
      let msg = form.querySelector('.popup-modal__msg--error');
      if (!msg) {
        msg = document.createElement('p');
        msg.className = 'popup-modal__msg popup-modal__msg--error';
        msg.setAttribute('role', 'alert');
        msg.setAttribute('aria-live', 'assertive');
        form.prepend(msg);
      }
      msg.textContent = 'Something went wrong. Please try again.';
      msg.hidden = false;
    }

    _copyDiscount(btn) {
      const code = btn.dataset.copyDiscount;
      if (!code) return;
      navigator.clipboard
        .writeText(code)
        .then(() => {
          const original = btn.textContent;
          btn.textContent = 'Copied!';
          btn.setAttribute('aria-label', 'Discount code copied');
          setTimeout(() => {
            btn.textContent = original;
            btn.setAttribute('aria-label', 'Copy discount code ' + code);
          }, 2000);
        })
        .catch(() => {
          const codeEl = btn.closest('[data-discount-block]');
          const target = codeEl ? codeEl.querySelector('[data-discount-code]') : null;
          if (target) {
            const range = document.createRange();
            range.selectNodeContents(target);
            const sel = window.getSelection();
            if (sel) {
              sel.removeAllRanges();
              sel.addRange(range);
            }
          }
        });
    }

    _setupCustomizerEvents() {
      console.log('[PopupModal] Setting up Shopify customizer events');

      // Bind close button and overlay even in design mode
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.hide());
      if (this.overlay) this.overlay.addEventListener('click', () => this.hide());

      // Bind copy discount buttons
      this.querySelectorAll('[data-copy-discount]').forEach((btn) => {
        btn.addEventListener('click', () => this._copyDiscount(btn));
      });

      // Listen for section select/deselect events
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          console.log('[PopupModal] Section selected in customizer');
          this.show();
        }
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          console.log('[PopupModal] Section deselected in customizer');
          this.hide();
        }
      });

      // Do NOT auto-show in the customizer. The popup opens only when this
      // section is clicked/selected (shopify:section:select) and closes on
      // deselect, so it no longer covers the editor on page load.
    }
  }

  customElements.define('popup-modal', PopupModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-view"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // AUTO-CHANGE FUNCTIONALITY
    const section = document.querySelector('[data-autochange]');
    if (section) {
      const autochange = section.dataset.autochange === 'true';
      const delay = parseInt(section.dataset.autochangeDelay, 10) || 6000;

      if (autochange) {
        let currentTabIndex = 0;
        let autoInterval;
        let isAutoChangePaused = false;
        const leftTabs = section.querySelectorAll('.middle-top > div[id]');

        if (leftTabs.length > 0) {
          function activateTab(tabIndex) {
            const tabs = Array.from(section.querySelectorAll('.middle-top > div[id]'));
            const allDots = section.querySelectorAll('.pagination-dots .dot');
            const counts = section.querySelectorAll('.count');
            const contentWrapTabs = section.querySelectorAll('.content-wrap .middle > div[id]');

            // Remove active class from all
            tabs.forEach((tab) => tab.classList.remove('active'));
            contentWrapTabs.forEach((tab) => tab.classList.remove('active'));
            allDots.forEach((dot) => dot.classList.remove('active'));
            counts.forEach((count) => count.classList.remove('active'));

            // Add active class to target tab
            if (tabs[tabIndex]) {
              tabs[tabIndex].classList.add('active');
              const tabName = tabs[tabIndex].id;

              // Also activate the corresponding content-wrap tab
              const contentWrapTab = section.querySelector(`.content-wrap .middle > div#${tabName}_1`);
              if (contentWrapTab) contentWrapTab.classList.add('active');

              // Activate all dots with matching data-tab
              section.querySelectorAll(`.pagination-dots .dot[data-tab="${tabName}"]`).forEach((dot) => {
                dot.classList.add('active');
              });

              // Also activate the corresponding count
              const activeCount = section.querySelector(`.count[data-tab="${tabName}"]`);
              if (activeCount) activeCount.classList.add('active');

              // Activate right-side content
              const rightContent = section.querySelector(`#${tabName}_1`);
              if (rightContent) rightContent.classList.add('active');
            }
          }

          function startAutoChange() {
            autoInterval = setInterval(() => {
              if (isAutoChangePaused) return;

              const tabs = Array.from(section.querySelectorAll('.middle-top > div[id]'));
              const nextIndex = (currentTabIndex + 1) % tabs.length;
              currentTabIndex = nextIndex;
              activateTab(nextIndex);
            }, delay);
          }

          // Intersection Observer to pause/resume auto-change based on viewport visibility
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  // Section is in viewport - resume auto-change
                  isAutoChangePaused = false;
                  // Reset to tab 1
                  currentTabIndex = 0;
                  activateTab(0);
                } else {
                  // Section is out of viewport - pause auto-change
                  isAutoChangePaused = true;
                }
              });
            },
            { threshold: 0.1 }
          );

          observer.observe(section);
          activateTab(0);
          startAutoChange();

          // Reset auto-change when user manually clicks
          const allClickable = section.querySelectorAll('.count, .pagination-dots .dot');
          allClickable.forEach((el) => {
            el.addEventListener('click', () => {
              clearInterval(autoInterval);
              const tabs = Array.from(section.querySelectorAll('.middle-top > div[id]'));
              const clickedTabName = el.getAttribute('data-tab');
              const clickedTabIndex = tabs.findIndex((tab) => tab.id === clickedTabName);
              if (clickedTabIndex !== -1) {
                currentTabIndex = clickedTabIndex;
              }
              activateTab(currentTabIndex);
              // Delay restart to allow click handler to complete
              setTimeout(startAutoChange, 100);
            });
          });
        }
      }
    }

    const canvas = document.getElementById('lab-section-canvas');
    if (!canvas) return;

    const ctx = canvas.getContext('2d', { willReadFrequently: true });

    // hidden mask canvas
    const mask = document.createElement('canvas');
    const mctx = mask.getContext('2d', { willReadFrequently: true });

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = canvas.dataset.imgSrc;
    img.onload = () => {
      canvas.width = mask.width = img.width;
      canvas.height = mask.height = img.height;

      // draw real image
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);

      // build mask by auto-segmenting non-transparent pixels into blobs
      buildMaskFromImage();
    };

    function buildMaskFromImage() {
      mctx.clearRect(0, 0, mask.width, mask.height);
      mctx.drawImage(img, 0, 0);

      const { width, height } = mask;
      const imageData = mctx.getImageData(0, 0, width, height);
      const data = imageData.data;

      const labels = new Int32Array(width * height).fill(-1);
      const alphaThreshold = 10;
      let currentLabel = 0;

      const idx = (x, y) => y * width + x;

      const queue = new Int32Array(width * height);
      let qh = 0,
        qt = 0;

      function isOpaqueAt(i) {
        return data[i * 4 + 3] > alphaThreshold;
      }

      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          const i = idx(x, y);
          if (labels[i] !== -1) continue;
          if (!isOpaqueAt(i)) continue;

          qh = 0;
          qt = 0;
          queue[qt++] = i;
          labels[i] = currentLabel;

          while (qh < qt) {
            const p = queue[qh++];
            const px = p % width;
            const py = (p / width) | 0;

            const neighbors = [
              [px - 1, py],
              [px + 1, py],
              [px, py - 1],
              [px, py + 1],
            ];

            for (const [nx, ny] of neighbors) {
              if (nx < 0 || nx >= width || ny < 0 || ny >= height) continue;
              const ni = idx(nx, ny);
              if (labels[ni] !== -1) continue;
              if (!isOpaqueAt(ni)) continue;
              labels[ni] = currentLabel;
              queue[qt++] = ni;
            }
          }

          currentLabel++;
        }
      }

      // paint the mask: each label => unique RGB color
      const maskData = new Uint8ClampedArray(data.length);
      for (let i = 0; i < width * height; i++) {
        const lab = labels[i];
        const o = i * 4;
        if (lab === -1) {
          maskData[o + 3] = 0;
          continue;
        }

        const code = lab + 1;
        maskData[o + 0] = (code >> 16) & 255;
        maskData[o + 1] = (code >> 8) & 255;
        maskData[o + 2] = code & 255;
        maskData[o + 3] = 255;
      }

      const out = new ImageData(maskData, width, height);
      mctx.putImageData(out, 0, 0);

      // store count for mapping
      canvas.dataset.pieceCount = String(currentLabel);
    }

    canvas.addEventListener('click', (e) => {
      const rect = canvas.getBoundingClientRect();
      const x = Math.floor((e.clientX - rect.left) * (canvas.width / rect.width));
      const y = Math.floor((e.clientY - rect.top) * (canvas.height / rect.height));

      const p = mctx.getImageData(x, y, 1, 1).data;
      if (p[3] === 0) return;

      const code = (p[0] << 16) | (p[1] << 8) | p[2];
      const pieceId = code - 1;

      // Hook for page-level logic: define `window.handleLabPieceClick` to receive pieceId
      if (typeof window.handleLabPieceClick === 'function') {
        window.handleLabPieceClick(pieceId, canvas);
      } else {
        console.log('Clicked piece:', pieceId);
        const parent = canvas.closest('.main_img');
        // fallback simple UI feedback
        // eslint-disable-next-line no-alert
        switch (pieceId) {
          case 0:
            if (parent?.querySelector('.count.one')) {
              parent.querySelector('.count.one').click();
            }
            break;
          case 1:
            if (parent?.querySelector('.count.three')) {
              parent.querySelector('.count.three').click();
            }
            break;
          case 2:
            if (parent?.querySelector('.count.two')) {
              parent.querySelector('.count.two').click();
            }
            break;
          case 3:
            if (parent?.querySelector('.count.four')) {
              parent.querySelector('.count.four').click();
            }
            break;
          case 4:
            if (parent?.querySelector('.count.four')) {
              parent.querySelector('.count.four').click();
            }
            break;
          case 5:
            if (parent?.querySelector('.count.five')) {
              parent.querySelector('.count.five').click();
            }
            break;
          case 6:
            if (parent?.querySelector('.count.six')) {
              parent.querySelector('.count.six').click();
            }
            break;
          default:
            console.log(`Clicked on piece ${pieceId}, this one is not registered in the default handler.`);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
